'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsxFileName = 'src/index.js'; /**
                                    * Created by kanghongyan<khongyan379@sina.com>.
                                    * ComponentName BundleLoader
                                    * Desc 组件描述内容
                                    * GroupName lm-component
                                    */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 * @param Comp 需要异步的组件
 * @param props
 * @param LoadingComp Loading组件，不传则没有loading效果
 * @return {*}
 *
 * @desc BundleLoader Component for mobile
 * @constructor
 */
var BundleLoader = function BundleLoader() {
    var Comp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var LoadingComp = arguments[2];


    return _react2.default.createElement(
        Bundle,
        _defineProperty({ load: Comp, loadingComp: LoadingComp, __source: {
                fileName: _jsxFileName,
                lineNumber: 25
            },
            __self: undefined
        }, '__self', undefined),
        function (Mod) {
            return _react2.default.createElement(Mod, Object.assign({}, props, _defineProperty({
                __source: {
                    fileName: _jsxFileName,
                    lineNumber: 26
                },
                __self: undefined
            }, '__self', undefined)));
        }
    );
};

var Bundle = function (_React$Component) {
    _inherits(Bundle, _React$Component);

    function Bundle() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Bundle);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bundle.__proto__ || Object.getPrototypeOf(Bundle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            // short for "module" but that's a keyword in js, so "mod"
            mod: null
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Bundle, [{
        key: 'componentDidMount',
        value: function componentDidMount() {

            this._isMounted = true;

            this.load(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.load !== this.props.load) {
                this.load(nextProps);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._isMounted = false;
        }
    }, {
        key: 'load',
        value: function load(props) {
            var _this2 = this;

            this.setState({
                mod: null
            });

            /*
            *  this.props.load
            *  内部会将执行callback，传入require()后的组件
            *  经webpack boundle-loader包装的组件
            *
            * module.exports = function(cb) {
            require.ensure([], function(require) {
            cb(require("!!../../node_modules/babel-loader/lib/index.js??ref--1-oneOf-1!../../node_modules/eslint-loader/index.js??ref--0-0!./page2.js"));
            }, "page2");
            }
            * */

            props.load().then(function (mod) {
                _this2._isMounted && _this2.setState({
                    mod: mod.default ? mod.default : mod
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {

            return this.state.mod ? this.props.children(this.state.mod) : this.props.loadingComp;
        }
    }]);

    return Bundle;
}(_react2.default.Component);

Bundle.propTypes = {
    mod: _propTypes2.default.node, // 异步加载的组件
    loadingComp: _propTypes2.default.node // loading组件
};
Bundle.defaultProps = {
    mod: null,
    loadingComp: null
};
exports.default = BundleLoader;
module.exports = exports['default'];